module.exports = __webpack_public_path__ + "img/hacker.e947a7a9.png";